export interface OverflowMeasurements {
  readonly clientHeight: number;
  readonly scrollHeight: number;
}

export interface ResizeObserverLike {
  disconnect(): void;
  observe(target: Element): void;
}

export type ResizeObserverFactory = (callback: ResizeObserverCallback) => ResizeObserverLike;

const OVERFLOW_TOLERANCE_PX = 1;

export function isMessageContentOverflowing(element: OverflowMeasurements): boolean {
  return element.scrollHeight > element.clientHeight + OVERFLOW_TOLERANCE_PX;
}

export function observeMessageContentOverflow(
  viewport: HTMLElement,
  content: HTMLElement,
  onChange: (overflowing: boolean) => void,
  resizeObserverFactory: ResizeObserverFactory = (callback) => new ResizeObserver(callback),
): () => void {
  const measure = () => onChange(isMessageContentOverflowing(viewport));
  const observer = resizeObserverFactory(measure);

  observer.observe(viewport);
  observer.observe(content);
  measure();

  return () => observer.disconnect();
}
